import type {
  IDeepLinkingService,
  DeepLinkListenerType,
} from './DeepLinkingService';

class DeepLinkingService implements IDeepLinkingService {
  getInitialLink() {
    return Promise.resolve(null);
  }

  onLink(_: DeepLinkListenerType) {
    return () => {};
  }
}

export default new DeepLinkingService();
